module.exports = __webpack_public_path__ + "img/logo.2d1af986.png";